<template>
  <v-expand-transition>
    <v-banner v-show="visible" single-line color="#1f243c">
      <div
        class="d-flex tp-text-subtitle-semibold-white justify-center align-center font-weight-medium"
      >
        {{ $t('vasario16') }}
      </div>
    </v-banner>
  </v-expand-transition>
</template>

<script>
export default {
  name: 'SpecialOccasionBanner',
  props: {
    locale: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  mounted() {
    if (this.$moment().isSame('2026-02-16', 'day') && this.locale === 'lt') {
      setTimeout(() => {
        this.visible = true;
      }, 600);
    }
  },
};
</script>
